<template>
  <md-tabs
    class="md-nav-color"
    md-sync-route
  >
    <template v-for="(item, index) in navItems">
      <md-tab
        :id="`tab-${item.name}`"
        :key="index"
        :md-label="`${item.name}`"
        :to="item.link"
      />
    </template>
    <md-tab
      id="contact"
      md-label="Kab Website"
      @click="tabChange"
    />
  </md-tabs>
</template>

<script>
import items from "./routesConfig";
export default {
  name: "MainNavBar",
  data() {
    return {
      navItems: items
    };
  },
  methods: {
    tabChange(value) {
      window.open('http://kampalabiennale.org/', '_blank')
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.md-nav-color {
  padding-left: 26px !important;
  padding-top: 13px;
  padding-bottom: 12px;
  &.md-theme-default {
    background-color: $color-white !important;
    .md-tabs-indicator {
      background-color: initial !important;
    }
  }
  .md-tab-nav-button { 
    font-size: 16px !important;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    text-indent: 10px;
    padding-right: 5px !important;
  }
}
</style>
